import React from "react";
import { IMAGES, FOOTER_LINKS } from "../../mock";

const Footer = () => {
  return (
    <>
      <section className="py-16 bg-white">
        <div className="max-w-[900px] mx-auto px-6 flex justify-center">
          <img
            src={IMAGES.logo}
            alt="Meilleurelec.fr"
            width={468}
            height={120}
            loading="lazy"
            decoding="async"
            className="h-12 md:h-14 w-auto object-contain"
          />
        </div>
      </section>

      <footer className="py-10" style={{ backgroundColor: "var(--me-bg)" }}>
        <div className="max-w-[900px] mx-auto px-6 text-center">
          <div className="flex flex-col items-center gap-2">
            <a
              href={FOOTER_LINKS.cgu}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[14px] font-medium hover:underline"
              style={{ color: "#53575e" }}
            >
              Nos CGU
            </a>
            <a
              href={FOOTER_LINKS.cookie}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[14px] font-medium hover:underline"
              style={{ color: "#53575e" }}
            >
              Notre Politique de cookie
            </a>
            <p className="mt-3 text-[13px]" style={{ color: "#8a8f98" }}>
              © ODYS EURL - 2024
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
